import type { ReactNode } from 'react'
import { s } from '../lib/sx'

const section = s('background:#1B2430;color:#F2F4F6;')
const eyebrowStyle = s("font-family:'IBM Plex Mono',monospace;font-size:11px;letter-spacing:0.24em;text-transform:uppercase;color:#E06A20;")

/** Dark banner at the top of every page except the home page. */
export function PageHero({ eyebrow, title, sub }: { eyebrow: string; title: ReactNode; sub?: ReactNode }) {
  return (
    <section style={section}>
      <div style={s('max-width:1320px;margin:0 auto;padding:clamp(48px,7vw,88px) clamp(18px,4vw,32px) 76px;')}>
        <div style={eyebrowStyle}>{eyebrow}</div>
        <h1
          style={s(
            `font-family:Archivo,sans-serif;font-weight:800;font-size:clamp(42px,5.8vw,80px);line-height:0.94;letter-spacing:-0.04em;margin:22px 0 ${sub ? '22px' : '0'};max-width:900px;`,
          )}
        >
          {title}
        </h1>
        {sub && <p style={s('font-size:18px;line-height:1.6;color:#B8C0CA;max-width:640px;margin:0;')}>{sub}</p>}
      </div>
    </section>
  )
}

/** Variant used by the three legal documents: smaller title, mono strapline. */
export function LegalHero({ title, meta }: { title: string; meta: string }) {
  return (
    <section style={section}>
      <div style={s('max-width:1320px;margin:0 auto;padding:clamp(48px,7vw,88px) clamp(18px,4vw,32px) 72px;')}>
        <div style={eyebrowStyle}>Legal</div>
        <h1 style={s('font-family:Archivo,sans-serif;font-weight:800;font-size:clamp(38px,4.8vw,68px);line-height:0.96;letter-spacing:-0.038em;margin:22px 0 20px;max-width:900px;')}>{title}</h1>
        <p style={s("font-family:'IBM Plex Mono',monospace;font-size:12.5px;letter-spacing:0.1em;color:#8C97A4;margin:0;")}>{meta}</p>
      </div>
    </section>
  )
}
